module.exports = __webpack_public_path__ + "static/img/right-num-row-6.9b5dc486.webp";